import React, { Component, PureComponent } from "react";
import { Metric, Error, selectFormat } from "components/Utils/Utils.js";
import Heading from "components/Elements/Heading.js";

const widgetConfig = {
  total_spend: {
    label: "Total Spend",
    type: "currency-GB",
  },
  acquisition_spend: {
    label: "Acquisition Spend",
    type: "currency-GB",
  },
  total_free_trial_starts: {
    label: "Total Free Trial Starts",
  },
  fts_from_paid_media: {
    label: "FTS From Paid Media",
  },
  purchases_percentage: {
    label: "% from Paid",
    type: "percentage",
  },
  overall_cpa: {
    label: "Overall CPA",
    type: "currency-GB",
  },
  paid_media_acq_cpa: {
    label: "Paid Media ACQ CPA",
    type: "currency-GB",
  },
  cpsub: {
    type: "currency-GB",
    label: "Est. Paying CPSub",
  },
  est_paid_media_acq_paying_cp_sub: {
    type: "currency-GB",
    label: "Est. Paid Media ACQ Paying CP Sub",
  },
};
class RenderMetric extends PureComponent {
  render() {
    const { data, type, label, size, format } = this.props;

    return (
      <div className="col-6 col-lg-3 mb-2">
        <Heading size={6} className={"mb-2"}>
          {label}
        </Heading>
        <Metric {...data} size={size} type={type} format={format} />
      </div>
    );
  }
}

class MarqueeTVKPIs extends Component {
  componentDidMount() {
    this.props.childRef(this);
  }

  renderMetrics = (data, cells) =>
    cells.map((metric, key) => {
      const metric_data = data[metric];
      const label = widgetConfig[metric].label;
      const type = widgetConfig[metric].type
        ? widgetConfig[metric].type
        : "number";
      const format = widgetConfig[metric].format;
      const size = key <= 3 ? "lg" : "md";
      return (
        <RenderMetric
          data={metric_data}
          type={type}
          label={label}
          size={size}
          format={format}
          key={key}
        />
      );
    });

  getExportData = () => {
    const { data, cells } = this.props;
    return {
      data: cells.map((metric) => ({
        Metric: widgetConfig[metric].label,
        Value: selectFormat(
          widgetConfig[metric].type,
          data.data[metric].value,
          widgetConfig[metric].format
        ),
      })),
      opts: {
        type: "other",
      },
    };
  };

  render() {
    const { data, cells } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    return (
      <div className="row mb-3 mb-md-0 mt-4 mt-md-0">
        {this.renderMetrics(data.data, cells)}
      </div>
    );
  }
}

export default MarqueeTVKPIs;
